module.exports = __webpack_public_path__ + "img/main-old.fb984232.jpg";